<template>
    <div class="card h-100 bg-white radius-20 p-0 border-0">
        <img src="/images/new_course_bg.jpeg" alt="" class="card-img-top">
        <div class="card-body px-5 py-3">
            <h2 class="card-title custom-card-title">Crea un curso propio</h2>
            <p>Puedes crear un curso, mencionar requerimientos y beneficios de crear un curso y específicar que solo son visibles para agregarlos a unas rutas</p>
            <button class="btn btn-primary px-5 text-light rounded-8 mx-auto d-block" @click="startCreatingCourse()">
                Comenzar
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            startCreatingCourse(){
                this.$emit('startCreation');
            }
        }
    }
</script>
<style>
    .radius-20{
        border-radius: 20px;
    }

    .custom-card-title{
        color: #1A0054;
        font-weight: 700;
        font-size: 35px;
    }
</style>
